import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import MatchHistory from './MatchHistory';
import Home from './Home';
import './styles.css';
import './animate.css';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/:username/:tag" element={<MatchHistory />} />
      </Routes>
    </Router>
  );
};

export default App;
